import { Color, FontWeight, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

export const SummaryContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
`

type SummaryLineProps = {
  withBorder?: boolean
}

export const SummaryLine = styled.li<SummaryLineProps>`
  display: flex;
  padding-top: ${Spacing.S4};
  padding-bottom: ${Spacing.S4};

  ${({ withBorder }) =>
    withBorder &&
    css`
      border-top: 1px solid ${Color.Grey200};
      border-bottom: 2px solid ${Color.Grey200};
    `}
`

export const LineValue = styled.p`
  flex-shrink: 0;
  min-width: 100px;
  margin-left: 30px;
  text-align: right;
`

export const LineHeader = styled.p`
  min-width: 100px;
  font-weight: ${FontWeight.Medium};
  text-align: right;
`
